"use client";

import React, { useEffect, useRef, useState } from "react";
// import UpdateProfile from "./UpdateProfile";
import ChangePasswordPopup from "./ChangePasswordPopup";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useRouter } from "next/navigation";
import { clearToken } from "@/Redux/slice/token";
import { logout } from "@/Redux/slice/userSlice";
import { clearChatState } from "@/Redux/slice/chatSlice";
import socketService, { connectSocket } from "../../../utils/socket";
import Notification from "@/Components/Common/Notification/Notification";
import { markNotificationAsRead } from "../../../Redux/slice/notificationSlice";
import useNotificationRefresh from "@/hooks/useNotificationRefresh";
import { useMarkAllAsReadMutation } from "../../../Redux/apis/notifications";
import { useUpdateProfileVisibilityMutation } from "../../../Redux/apis/doctor";
import { userData } from "@/Redux/apis/userData";
import Loader from "../../Common/Loader/Loader";
import EditLocation from "./EditLocation";
import DoctorsEditProfile from "./DoctorsEditProfile";
import dayjs from "dayjs";
import dynamic from "next/dynamic";
import { toast } from "react-toastify";
import Avatar from "react-avatar";
import { firstValidProfileUrl } from "@/utils/imageUrl";
import RepCompaniesManager from "@/Components/RepDashboard/RepCompanies/RepCompaniesManager";
import { ChevronDown } from "lucide-react";
import { FaSearch } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { LuPenLine, LuLogOut, LuLock, LuBuilding2 } from "react-icons/lu";
import Image from "next/image";
import { useSidebar } from "@/context/SidebarContext";
const DynamicComponentWithNoSSR = dynamic(() => import('./UpdateProfile'), {
  ssr: false
});
const Navbar = () => {
  const [visibility, setVisibility] = useState("Private");
  const [isOpen, setIsOpen] = useState(false);
  const [load, setLoad] = useState(false);
  const token = useSelector(state => state?.token?.token);
  const users = useSelector(state_0 => state_0?.userData?.userData?.user);
  const refreshNotifications = useNotificationRefresh(users?._id);

  // Get sidebar context for mobile menu
  let sidebarContext = null;
  try {
    sidebarContext = useSidebar();
  } catch (e) {
    // Context not available (e.g., on public pages)
  }
  const openMobileSidebar = sidebarContext?.openMobileSidebar;
  const dispatch = useDispatch();
  let optionRef = useRef();
  const router = useRouter();
  const notificationTotalUnreadCount = useSelector(state_1 => state_1.notifications?.totalUnreadCount);
  const [updateVisibility, response] = useUpdateProfileVisibilityMutation();
  useEffect(() => {
    if (users && users?._id) {
      socketService?.connect(users?._id, router);
      setVisibility(users?.isPrivate ? 'Private' : 'Public');
    }
  }, [users]);
  const userLogout = () => {
    setIsOpenProfile(false);
    setLoad(true);
    Cookies.remove("token");
    Cookies.remove("isReps");
    window.location.href = "/login";
  };
  useEffect(() => {
    let handler = e_0 => {
      if (!optionRef?.current?.contains(e_0.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });
  const handleVisibilityChange = async option => {
    setVisibility(option);
    setIsOpen(false);
    await updateVisibility({
      id: users?._id,
      visibility: option
    });
  };
  useEffect(() => {
    const handleResponse = async () => {
      if (response?.isLoading) {
        setLoad(true);
      } else if (!response?.isLoading && response?.isSuccess) {
        const responseData = response?.data?.user;
        setVisibility(responseData?.isPrivate ? 'Private' : 'Public');
        const data = {
          token: token
        };
        toast.success("Visibility update successfully!");
        await dispatch(userData(data));
        setLoad(false);
      } else if (response?.isError && response?.status === "rejected" && response?.error?.status === 400) {
        toast.error(response?.error?.data?.message);
        setLoad(false);
      }
    };
    handleResponse();
  }, [response]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [isUpdateProfileOpen, setIsUpdateProfileOpen] = useState(false);
  const openUpdateProfilePopUp = () => {
    setIsUpdateProfileOpen(true);
  };
  const closeUpdateProfilePopup = () => {
    setIsUpdateProfileOpen(false);
  };
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  let menuRef = useRef();
  useEffect(() => {
    let handler_0 = e_1 => {
      if (!menuRef?.current?.contains(e_1.target)) {
        setIsOpenProfile(false);
      }
    };
    document.addEventListener("mousedown", handler_0);
    return () => {
      document.removeEventListener("mousedown", handler_0);
    };
  }, [isOpenProfile]);
  const [isLocationDropdownOpen, setLocation] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("Mumbai, Maharashtra");
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setLocation(!isLocationDropdownOpen);
  };
  const selectLocation = location => {
    setSelectedLocation(location);
    setLocation(false);
  };
  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setLocation(false);
    }
  };
  useEffect(() => {
    if (isLocationDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isLocationDropdownOpen]);
  const [isNotificationOpen, setNotification] = useState(false);
  const notificationRef = useRef(null);
  const companyRef = useRef(null);
  const [markAllAsReadApi] = useMarkAllAsReadMutation();

  /**
   * Open/close the notification dropdown. UX rule: opening the dropdown
   * refreshes the list before marking the displayed notifications as seen.
   * Keep newer arrivals unread and only clear badges after the server confirms.
   */
  const toggleNotification = async () => {
    const opening = !isNotificationOpen;
    setNotification(opening);
    if (opening) {
      const result = await refreshNotifications();
      const unread = (result?.payload?.data || []).filter(item => item?._id && !item.isRead);
      if (unread.length > 0) {
        try {
          await markAllAsReadApi({
            notificationIds: unread.map(item_0 => item_0._id)
          }).unwrap();
          unread.forEach(item_1 => dispatch(markNotificationAsRead({
            notificationId: item_1._id,
            type: item_1.type
          })));
        } catch (err) {
          console.error("[Navbar] markAllAsRead failed:", err);
        }
      }
    }
  };
  const handleClickOutsideNotification = event_0 => {
    if (notificationRef.current && !notificationRef.current.contains(event_0.target)) {
      setNotification(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideNotification);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideNotification);
    };
  }, []);
  const toggleCompanyMenu = () => {
    setCompanyMenuOpen(!companyMenuOpen);
  };
  const handleClickOutsideCompany = event_1 => {
    if (companyRef.current && !companyRef.current.contains(event_1.target)) {
      setCompanyMenuOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideCompany);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCompany);
    };
  }, []);
  const [isEditLocationPopupOpen, setEditLocationPopup] = useState(false);
  const handelOpenEditLocationPopup = () => {
    setEditLocationPopup(true);
  };
  const handelCloseLocationPopup = () => {
    setEditLocationPopup(false);
  };
  const formatAddress = users_0 => {
    if (users_0?.addressDetails) {
      const {
        area,
        state: state_2
      } = users_0.addressDetails;
      return `${area || ''}${area ? ', ' : ''}${state_2 || ''}`;
    }
    return users_0?.state || 'Add Location';
  };
  const [isEditDoctorsProfileOpen, setEditDcotorsProfile] = useState(false);
  const openDoctorsEditProfile = () => {
    setEditDcotorsProfile(true);
  };
  const closeDoctorsEditProfile = () => {
    setEditDcotorsProfile(false);
  };
  const [is404, setIs404] = useState(true);
  useEffect(() => {
    let title = document.title;
    if (title.includes("404:")) {
      setIs404(true);
    } else {
      setIs404(false);
    }
  }, []);
  const [companyMenuOpen, setCompanyMenuOpen] = useState(false);
  const [mobileCompanyOpen, setMobileCompanyOpen] = useState(false);

  // Reps can represent several companies; the navbar shows the primary one.
  const otherCompanyCount = new Set((users?.companies || []).map(company => String(company?.id || "")).filter(id => id && id !== String(users?.primaryManufacturerId || ""))).size;
  const companyLabel = users?.companyName ? `${users.companyName}${otherCompanyCount ? ` +${otherCompanyCount}` : ""}` : "Add company";
  return <>
      {load && <div className="fixed inset-0 z-[99999999]"><Loader /></div>}
      {users && !is404 && <div className={`h-auto min-h-[90px] lg:h-[86px] items-center flex flex-wrap lg:flex-nowrap justify-between px-2 lg:px-8 py-3 lg:py-4 bg-white z-[11] w-full gap-2 lg:gap-0`}>
        <div className="flex-shrink-0 flex items-start max-md:items-center gap-2 sm:gap-3">
          {/* Mobile hamburger menu button */}
          {openMobileSidebar && <button onClick={openMobileSidebar} className="lg:hidden p-2 -ml-1 rounded-lg hover:bg-gray-100 transition-colors mt-0.5" aria-label="Open menu">
              <HiOutlineMenuAlt2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-700" />
            </button>}
          <div className="flex flex-col">
            <p className="text-[14px] sm:text-[16px] lg:text-[20px] font-light text-[#8E8E8E] font-poppins">
              Welcome,{" "}
              <span className="text-black font-semibold">
                {users ? users?.firstName : ""}
              </span>{" "}
              👋
            </p>
            {(users?.type === "physician" || users?.type === "clinic") && <div ref={dropdownRef} className="relative hidden sm:inline-block text-left mt-1">
                <div>
                  <div className="inline-flex justify-between w-full rounded-md cursor-pointer text-sm font-medium text-gray-700" onClick={() => toggleDropdown()}>
                    <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none">
                      <path d="M4.99998 0.333008C2.42331 0.333008 0.333313 2.42301 0.333313 4.99968C0.333313 8.49968 4.99998 13.6663 4.99998 13.6663C4.99998 13.6663 9.66665 8.49968 9.66665 4.99968C9.66665 2.42301 7.57665 0.333008 4.99998 0.333008ZM4.99998 6.66634C4.07998 6.66634 3.33331 5.91968 3.33331 4.99968C3.33331 4.07968 4.07998 3.33301 4.99998 3.33301C5.91998 3.33301 6.66665 4.07968 6.66665 4.99968C6.66665 5.91968 5.91998 6.66634 4.99998 6.66634Z" fill="#354EF0" />
                    </svg>
                    <span className="ml-2 text-[#1F1F1F] font-poppins text-[12px] font-normal">
                      {formatAddress(users)}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8.22176 10.8839L12.6228 6.4828C12.7464 6.35483 12.8148 6.18342 12.8133 6.00551C12.8118 5.82759 12.7404 5.6574 12.6146 5.5316C12.4888 5.40579 12.3186 5.33442 12.1407 5.33288C11.9628 5.33133 11.7914 5.39973 11.6634 5.52333L7.73999 9.44671L3.81661 5.52333C3.68863 5.39973 3.51723 5.33133 3.33931 5.33288C3.1614 5.33442 2.99121 5.40579 2.8654 5.5316C2.73959 5.6574 2.66823 5.82759 2.66668 6.00551C2.66514 6.18342 2.73353 6.35483 2.85713 6.4828L7.25822 10.8839C7.32144 10.9471 7.39658 10.9972 7.47927 11.0312C7.56196 11.0652 7.65058 11.0825 7.73999 11.082C7.91506 11.082 8.08877 11.0169 8.22176 10.8839Z" fill="#1F1F1F" />
                    </svg>
                  </div>
                </div>
              </div>

              {isLocationDropdownOpen && <div className="z-[11] absolute left-0 mt-2 w-[300px]  cursor-pointer rounded-md shadow-xl bg-white ring-1 ring-black ring-opacity-5">
                  <div className="px-3">
                    {users?.addressDetails ? <div>
                      <div className="text-[#7E84A3] text-[12px] font-inter pt-1 font-normal">Saved Address</div>
                      <div className="flex justify-between items-center pt-2 ">
                        <div className="flex items-center gap-1">
                          <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                              <g clipPath="url(#clip0_2916_6156)">
                                <path d="M4.66667 1.83301C2.09 1.83301 0 3.92301 0 6.49968C0 9.99968 4.66667 15.1663 4.66667 15.1663C4.66667 15.1663 9.33333 9.99968 9.33333 6.49968C9.33333 3.92301 7.24333 1.83301 4.66667 1.83301ZM4.66667 8.16634C3.74667 8.16634 3 7.41968 3 6.49968C3 5.57968 3.74667 4.83301 4.66667 4.83301C5.58667 4.83301 6.33333 5.57968 6.33333 6.49968C6.33333 7.41968 5.58667 8.16634 4.66667 8.16634Z" fill="#7E84A3" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2916_6156">
                                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className="text-[14px] text-[#131523] font-inter font-semibold">{users?.addressDetails?.area}</div>
                        </div>
                        <div onClick={handelOpenEditLocationPopup}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3.17331 12.5397C3.17331 12.5397 3.22665 12.5397 3.24665 12.5397L5.19998 12.3597C5.47331 12.3331 5.72665 12.2131 5.91998 12.0197L13.2933 4.64641C13.64 4.29974 13.8333 3.83974 13.8333 3.35307C13.8333 2.86641 13.64 2.40641 13.2933 2.05974L12.82 1.58641C12.1266 0.893073 10.92 0.893073 10.2266 1.58641L9.28665 2.52641L2.85998 8.95307C2.66665 9.14641 2.54665 9.39974 2.52665 9.67307L2.34665 11.6264C2.32665 11.8731 2.41331 12.1131 2.58665 12.2931C2.74665 12.4531 2.95331 12.5397 3.17331 12.5397ZM11.5266 2.04641C11.74 2.04641 11.9533 2.12641 12.1133 2.29307L12.5866 2.76641C12.7466 2.92641 12.8333 3.13307 12.8333 3.35307C12.8333 3.57307 12.7466 3.78641 12.5866 3.93974L12 4.52641L10.3533 2.87974L10.94 2.29307C11.1 2.13307 11.3133 2.04641 11.5266 2.04641ZM3.51998 9.76641C3.51998 9.72641 3.53998 9.69307 3.56665 9.66641L9.63998 3.58641L11.2866 5.23307L5.21331 11.3064C5.21331 11.3064 5.14665 11.3531 5.11331 11.3531L3.35998 11.5131L3.51998 9.75974V9.76641ZM15.1666 14.6664C15.1666 14.9397 14.94 15.1664 14.6666 15.1664H1.33331C1.05998 15.1664 0.833313 14.9397 0.833313 14.6664C0.833313 14.3931 1.05998 14.1664 1.33331 14.1664H14.6666C14.94 14.1664 15.1666 14.3931 15.1666 14.6664Z" fill="#354EF0" />
                          </svg>
                        </div>
                      </div>
                      <div className="text-[10px] pb-4 text-[#676767] font-poppins font-normal">
                        {users?.addressDetails?.address}
                      </div>
                    </div> : <div onClick={handelOpenEditLocationPopup} className="flex items-center gap-1 cursor-pointer border-b py-4 justify-start px-3">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 5.85714C6.82132 5.85714 5.85712 6.82143 5.85712 8C5.85712 9.17868 6.82132 10.1429 8 10.1429C9.17871 10.1429 10.1428 9.17868 10.1428 8C10.1428 6.82143 9.17871 5.85714 8 5.85714ZM13.1144 7.42858C12.8571 5.05721 10.9428 3.14287 8.57142 2.88575V2H7.42858V2.88572C5.05721 3.14284 3.14287 5.05719 2.88562 7.42855H2V8.57142H2.88559C3.14284 10.9428 5.05716 12.8571 7.42855 13.1144V14H8.57139V13.1144C10.9428 12.8572 12.8571 10.9428 13.1144 8.57145H14V7.42858H13.1144ZM8 12C5.7999 12 3.99998 10.2 3.99998 8C3.99998 5.79993 5.7999 4.00001 8 4.00001C10.2 4.00001 12 5.79996 12 8C12 10.2 10.2 12 8 12Z" fill="#1E5EFF" />
                          </svg>
                        </div>
                        <div className="text-[#1E5EFF] cursor-pointer text-[12px] font-medium font-poppins">
                          Add location
                        </div>
                      </div>}
                  </div>
                </div>}
            </div>}
          </div>
        </div>
        <div className="flex flex-row gap-2 lg:gap-6 capitalize items-center">
          {(users?.type === "physician" || users?.type === "clinic") && <div className="relative hidden sm:block" ref={optionRef}>
              <button onClick={() => {
            setIsOpen(!isOpen);
          }} className="h-10 flex items-center gap-3 border border-[#354EF0] p-2 rounded-md">
                <span className="text-[#4B4B4B] text-[12px] font-medium">
                  Profile Visibility:
                </span>
                <span className="text-[#4B4B4B] text-[12px] font-medium">
                  {visibility}
                </span>
                <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M11.7772 2.84763C11.6289 2.69917 11.4531 2.625 11.2499 2.625H0.750056C0.546802 2.625 0.371088 2.69917 0.222628 2.84763C0.0741683 2.99625 0 3.17197 0 3.3751C0 3.57819 0.0741683 3.7539 0.222628 3.9024L5.47257 9.15235C5.6212 9.30081 5.79691 9.37514 6 9.37514C6.20309 9.37514 6.37897 9.30081 6.52731 9.15235L11.7772 3.90236C11.9255 3.7539 12 3.57819 12 3.37506C12 3.17197 11.9255 2.99625 11.7772 2.84763Z" fill="#354EF0" />
                </svg>
              </button>
              {isOpen && <div className="absolute z-50 top-10 p-3 w-[211px] h-[172px] -right-6 mt-1   bg-white border border-gray-200 rounded-md shadow-md">
                  <button onClick={() => handleVisibilityChange("Private")} className="  py-2 text-sm border-b  text-gray-800">
                    <div className="flex gap-2">
                      {visibility === 'Private' && <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="mt-0.5">
                        <g clipPath="url(#clip0_783_5622)">
                          <path d="M9.98637 8.13472L10.8951 7.22597C10.9613 7.47334 11 7.73197 11 7.99997C11 9.65422 9.65425 11 8 11C7.732 11 7.47337 10.9612 7.226 10.8951L8.13475 9.98634C9.12838 9.91859 9.91862 9.12835 9.98637 8.13472ZM15.937 7.75709C15.8755 7.64647 15.0033 6.1181 13.2983 4.82285L12.5706 5.55047C13.8139 6.4646 14.6016 7.53072 14.9117 8.00072C14.3191 8.90309 11.9944 12 8 12C7.401 12 6.844 11.9233 6.31987 11.8011L5.49825 12.6227C6.25362 12.8543 7.08388 13 8 13C13.2341 13 15.8291 8.43697 15.937 8.24285C16.021 8.09172 16.021 7.90822 15.937 7.75709ZM13.8535 2.85347L2.8535 13.8535C2.75587 13.9511 2.62788 14 2.5 14C2.37212 14 2.24413 13.9511 2.1465 13.8535C1.95113 13.6581 1.95113 13.3417 2.1465 13.1465L3.546 11.747C1.2835 10.3811 0.133875 8.37047 0.063 8.24285C-0.021 8.09172 -0.021 7.90809 0.063 7.75697C0.170875 7.56297 2.76587 2.99997 8 2.99997C9.35337 2.99997 10.5256 3.30872 11.5278 3.76522L13.1465 2.14647C13.3419 1.9511 13.6583 1.9511 13.8535 2.14647C14.0487 2.34185 14.0489 2.65822 13.8535 2.85347ZM4.29163 11.0013L5.5575 9.73547C5.20787 9.24497 5 8.64684 5 7.99997C5 6.34572 6.34575 4.99997 8 4.99997C8.64688 4.99997 9.245 5.20785 9.7355 5.55735L10.7591 4.53372C9.95037 4.20985 9.03137 3.99997 8 3.99997C4.00562 3.99997 1.68087 7.09684 1.08837 7.99922C1.46463 8.56947 2.54612 10.013 4.29163 11.0013ZM6.28337 9.00947L9.0095 6.28334C8.71212 6.10772 8.36975 5.99997 8 5.99997C6.89725 5.99997 6 6.89722 6 7.99997C6 8.36972 6.10775 8.71209 6.28337 9.00947Z" fill="#354EF0" />
                        </g>
                        <defs>
                          <clipPath id="clip0_783_5622">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>}
                      {visibility !== 'Private' && <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="mt-0.5">
                        <g clipPath="url(#clip0_783_5622)">
                          <path d="M9.98637 8.13472L10.8951 7.22597C10.9613 7.47334 11 7.73197 11 7.99997C11 9.65422 9.65425 11 8 11C7.732 11 7.47337 10.9612 7.226 10.8951L8.13475 9.98634C9.12838 9.91859 9.91862 9.12835 9.98637 8.13472ZM15.937 7.75709C15.8755 7.64647 15.0033 6.1181 13.2983 4.82285L12.5706 5.55047C13.8139 6.4646 14.6016 7.53072 14.9117 8.00072C14.3191 8.90309 11.9944 12 8 12C7.401 12 6.844 11.9233 6.31987 11.8011L5.49825 12.6227C6.25362 12.8543 7.08388 13 8 13C13.2341 13 15.8291 8.43697 15.937 8.24285C16.021 8.09172 16.021 7.90822 15.937 7.75709ZM13.8535 2.85347L2.8535 13.8535C2.75587 13.9511 2.62788 14 2.5 14C2.37212 14 2.24413 13.9511 2.1465 13.8535C1.95113 13.6581 1.95113 13.3417 2.1465 13.1465L3.546 11.747C1.2835 10.3811 0.133875 8.37047 0.063 8.24285C-0.021 8.09172 -0.021 7.90809 0.063 7.75697C0.170875 7.56297 2.76587 2.99997 8 2.99997C9.35337 2.99997 10.5256 3.30872 11.5278 3.76522L13.1465 2.14647C13.3419 1.9511 13.6583 1.9511 13.8535 2.14647C14.0487 2.34185 14.0489 2.65822 13.8535 2.85347ZM4.29163 11.0013L5.5575 9.73547C5.20787 9.24497 5 8.64684 5 7.99997C5 6.34572 6.34575 4.99997 8 4.99997C8.64688 4.99997 9.245 5.20785 9.7355 5.55735L10.7591 4.53372C9.95037 4.20985 9.03137 3.99997 8 3.99997C4.00562 3.99997 1.68087 7.09684 1.08837 7.99922C1.46463 8.56947 2.54612 10.013 4.29163 11.0013ZM6.28337 9.00947L9.0095 6.28334C8.71212 6.10772 8.36975 5.99997 8 5.99997C6.89725 5.99997 6 6.89722 6 7.99997C6 8.36972 6.10775 8.71209 6.28337 9.00947Z" fill="#1F1F1F" />
                        </g>
                        <defs>
                          <clipPath id="clip0_783_5622">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>}
                      <span className={`${visibility === 'Private' ? 'text-[#354EF0]' : 'text-[#1F1F1F]'} text-[12px] font-semibold`}>
                        Private Mode
                      </span>
                    </div>

                    <p className="flex text-start justify-start">
                      This will make your profile invisible to all the reps
                    </p>
                  </button>

                  <button onClick={() => handleVisibilityChange("Public")} className="  py-2 text-sm text-gray-800">
                    <div className="flex justify-start gap-2  ">
                      {visibility === 'Public' && <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="mt-0.5">
                        <path d="M15.8983 7.68882C15.7554 7.49329 12.3496 2.90112 7.99992 2.90112C3.65019 2.90112 0.244313 7.49329 0.101531 7.68863C-0.0338438 7.87413 -0.0338438 8.12573 0.101531 8.31123C0.244313 8.50676 3.65019 13.0989 7.99992 13.0989C12.3496 13.0989 15.7554 8.50673 15.8983 8.31138C16.0339 8.12592 16.0339 7.87413 15.8983 7.68882ZM7.99992 12.044C4.79588 12.044 2.02085 8.99607 1.19938 7.99966C2.01979 7.00238 4.78901 3.95606 7.99992 3.95606C11.2038 3.95606 13.9787 7.00344 14.8005 8.00038C13.9801 8.99763 11.2108 12.044 7.99992 12.044Z" fill="#354EF0" />
                        <path d="M7.99981 4.83521C6.25474 4.83521 4.83496 6.25499 4.83496 8.00006C4.83496 9.74512 6.25474 11.1649 7.99981 11.1649C9.74488 11.1649 11.1647 9.74512 11.1647 8.00006C11.1647 6.25499 9.74488 4.83521 7.99981 4.83521ZM7.99981 10.1099C6.83637 10.1099 5.88993 9.16346 5.88993 8.00006C5.88993 6.83665 6.8364 5.89018 7.99981 5.89018C9.16322 5.89018 10.1097 6.83665 10.1097 8.00006C10.1097 9.16346 9.16325 10.1099 7.99981 10.1099Z" fill="#354EF0" />
                      </svg>}
                      {visibility !== 'Public' && <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="mt-0.5">
                        <path d="M15.8983 7.68882C15.7554 7.49329 12.3496 2.90112 7.99992 2.90112C3.65019 2.90112 0.244313 7.49329 0.101531 7.68863C-0.0338438 7.87413 -0.0338438 8.12573 0.101531 8.31123C0.244313 8.50676 3.65019 13.0989 7.99992 13.0989C12.3496 13.0989 15.7554 8.50673 15.8983 8.31138C16.0339 8.12592 16.0339 7.87413 15.8983 7.68882ZM7.99992 12.044C4.79588 12.044 2.02085 8.99607 1.19938 7.99966C2.01979 7.00238 4.78901 3.95606 7.99992 3.95606C11.2038 3.95606 13.9787 7.00344 14.8005 8.00038C13.9801 8.99763 11.2108 12.044 7.99992 12.044Z" fill="#1F1F1F" />
                        <path d="M7.99981 4.83521C6.25474 4.83521 4.83496 6.25499 4.83496 8.00006C4.83496 9.74512 6.25474 11.1649 7.99981 11.1649C9.74488 11.1649 11.1647 9.74512 11.1647 8.00006C11.1647 6.25499 9.74488 4.83521 7.99981 4.83521ZM7.99981 10.1099C6.83637 10.1099 5.88993 9.16346 5.88993 8.00006C5.88993 6.83665 6.8364 5.89018 7.99981 5.89018C9.16322 5.89018 10.1097 6.83665 10.1097 8.00006C10.1097 9.16346 9.16325 10.1099 7.99981 10.1099Z" fill="#1F1F1F" />
                      </svg>}
                      <span className={`${visibility === 'Public' ? 'text-[#354EF0]' : 'text-[#1F1F1F]'} text-[12px] font-semibold`}>
                        Public Mode
                      </span>
                    </div>

                    <p className="flex text-start justify-start">
                      This will make your profile visible to all the reps{" "}
                    </p>
                  </button>
                </div>}
            </div>}  
          {users?.type === "reps" && <div className="relative hidden md:block" ref={companyRef}>
              <button type="button" onClick={toggleCompanyMenu} aria-expanded={companyMenuOpen} className="w-[10rem] lg:w-[17rem] relative cursor-pointer border px-2 lg:px-3 py-2 rounded-lg flex items-center justify-between gap-2">
                <p title={companyLabel} className="capitalize text-xs lg:text-sm truncate-ellipsis">Company: {companyLabel}</p> <ChevronDown size={18} />
              </button>
              {companyMenuOpen && <div className="w-[22rem] h-[440px] max-h-[70vh] rounded-lg border border-gray-100 overflow-hidden flex flex-col absolute top-12 z-50 bg-white shadow-lg right-0">
                  <RepCompaniesManager onClose={() => setCompanyMenuOpen(false)} />
                </div>}
            </div>}

          <div key={"UNREAD_NOTIFICATION_COUNT_" + notificationTotalUnreadCount} onClick={toggleNotification} className="w-10 h-10 p-2 cursor-pointer lg:bg-[#F5F6F5]  rounded-md justify-start items-center gap-4 inline-flex">
            <div className="w-6 h-6 relative">
              {notificationTotalUnreadCount > 0 && <span className="absolute -top-1 -right-1 text-[10px] font-bold flex items-center justify-center rounded-full text-white bg-[#354EF0] h-4 w-4">{notificationTotalUnreadCount}</span>}
              {notificationTotalUnreadCount > 0 ? <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M10.9844 24C8.91748 24 7.23438 22.318 7.23438 20.25C7.23438 19.836 7.57037 19.5 7.98438 19.5C8.39838 19.5 8.73438 19.836 8.73438 20.25C8.73438 21.4911 9.74438 22.5 10.9844 22.5C12.2244 22.5 13.2344 21.4911 13.2344 20.25C13.2344 19.836 13.5704 19.5 13.9844 19.5C14.3984 19.5 14.7344 19.836 14.7344 20.25C14.7344 22.318 13.0515 24 10.9844 24Z" fill="#8E8E8E" />
                  <path d="M19.2343 21H2.73431C1.76935 21 0.984375 20.215 0.984375 19.2501C0.984375 18.7379 1.2074 18.2531 1.59631 17.92C1.6214 17.898 1.64832 17.8781 1.67633 17.8599C3.14429 16.5789 3.98438 14.736 3.98438 12.7899V9.99994C3.98438 6.14008 7.12537 3 10.9843 3C11.1443 3 11.3174 3.00293 11.4774 3.03003C11.8863 3.09796 12.1624 3.48505 12.0943 3.89301C12.0264 4.30096 11.6323 4.57709 11.2313 4.50897C11.1513 4.49597 11.0634 4.5 10.9843 4.5C7.95245 4.5 5.48438 6.96698 5.48438 9.99994V12.7899C5.48438 15.206 4.42529 17.4921 2.58142 19.0609C2.56641 19.073 2.55341 19.084 2.53729 19.095C2.51038 19.129 2.48438 19.181 2.48438 19.2501C2.48438 19.3859 2.59845 19.5 2.73431 19.5H19.2343C19.3704 19.5 19.4844 19.3859 19.4844 19.2501C19.4844 19.1799 19.4584 19.129 19.4304 19.095C19.4154 19.084 19.4024 19.073 19.3874 19.0609C17.5424 17.491 16.4844 15.206 16.4844 12.7899V11.7001C16.4844 11.2861 16.8204 10.9501 17.2344 10.9501C17.6484 10.9501 17.9844 11.2861 17.9844 11.7001V12.7899C17.9844 14.7371 18.8254 16.5809 20.2954 17.863C20.3223 17.881 20.3483 17.9 20.3723 17.9211C20.7614 18.2531 20.9844 18.7379 20.9844 19.2501C20.9844 20.215 20.1995 21 19.2343 21Z" fill="#8E8E8E" />
                </svg> : <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5.25C11.9015 5.25003 11.804 5.23064 11.713 5.19296C11.622 5.15528 11.5393 5.10004 11.4696 5.03039C11.4 4.96074 11.3447 4.87805 11.307 4.78704C11.2694 4.69604 11.25 4.5985 11.25 4.5V3C11.25 2.80109 11.329 2.61032 11.4697 2.46967C11.6103 2.32902 11.8011 2.25 12 2.25C12.1989 2.25 12.3897 2.32902 12.5303 2.46967C12.671 2.61032 12.75 2.80109 12.75 3V4.5C12.75 4.5985 12.7306 4.69604 12.693 4.78704C12.6553 4.87805 12.6 4.96074 12.5304 5.03039C12.4607 5.10004 12.378 5.15528 12.287 5.19296C12.196 5.23064 12.0985 5.25003 12 5.25Z" fill="#8E8E8E" />
                    <path d="M19.1249 19.5H4.87492C4.7471 19.4999 4.62141 19.4672 4.50978 19.4049C4.39814 19.3427 4.30427 19.2529 4.23707 19.1442C4.16986 19.0355 4.13155 18.9114 4.12577 18.7837C4.11999 18.656 4.14692 18.5289 4.20403 18.4145C5.13598 16.5451 5.62232 14.4851 5.62492 12.3962V10.125C5.62492 8.43425 6.29657 6.81274 7.49212 5.61719C8.68766 4.42165 10.3092 3.75 11.9999 3.75C13.6907 3.75 15.3122 4.42165 16.5077 5.61719C17.7033 6.81274 18.3749 8.43425 18.3749 10.125V12.3962C18.3775 14.4851 18.8639 16.5451 19.7958 18.4145C19.8529 18.5289 19.8799 18.656 19.8741 18.7837C19.8683 18.9114 19.83 19.0355 19.7628 19.1442C19.6956 19.2529 19.6017 19.3427 19.4901 19.4049C19.3784 19.4672 19.2527 19.4999 19.1249 19.5ZM6.03471 18H17.9648C17.2472 16.2188 16.8772 14.3166 16.8749 12.3962V10.125C16.8749 8.83207 16.3613 7.59209 15.4471 6.67785C14.5328 5.76361 13.2929 5.25 11.9999 5.25C10.707 5.25 9.46702 5.76361 8.55278 6.67785C7.63854 7.59209 7.12492 8.83207 7.12492 10.125V12.3962C7.1225 14.3166 6.75243 16.2188 6.03471 18Z" fill="#8E8E8E" />
                    <path d="M13.5 21.75H10.5C10.3011 21.75 10.1103 21.671 9.96967 21.5303C9.82902 21.3897 9.75 21.1989 9.75 21C9.75 20.8011 9.82902 20.6103 9.96967 20.4697C10.1103 20.329 10.3011 20.25 10.5 20.25H13.5C13.6989 20.25 13.8897 20.329 14.0303 20.4697C14.171 20.6103 14.25 20.8011 14.25 21C14.25 21.1989 14.171 21.3897 14.0303 21.5303C13.8897 21.671 13.6989 21.75 13.5 21.75Z" fill="#354EF0" />
                    <path d="M19.5 19.5H4.5C4.30109 19.5 4.11032 19.421 3.96967 19.2803C3.82902 19.1397 3.75 18.9489 3.75 18.75C3.75 18.5511 3.82902 18.3603 3.96967 18.2197C4.11032 18.079 4.30109 18 4.5 18H19.5C19.6989 18 19.8897 18.079 20.0303 18.2197C20.171 18.3603 20.25 18.5511 20.25 18.75C20.25 18.9489 20.171 19.1397 20.0303 19.2803C19.8897 19.421 19.6989 19.5 19.5 19.5Z" fill="#8E8E8E" />
                  </svg>
                </div>}
            </div>
          </div>
          {isNotificationOpen && <div className="w-full fixed inset-0 popup-bg z-50">
              <div ref={notificationRef} className="absolute right-2 lg:right-10 mt-10 rounded-lg shadow-lg w-[calc(100vw-16px)] sm:w-[400px] lg:w-[450px] max-h-[80vh] overflow-y-auto no-scrollbar">
                <Notification setNotification={setNotification} />
              </div>
            </div>}

          <div className="relative" ref={menuRef}>
            <div className=" cursor-pointer h-10 p-2 bg-stone-50 rounded-md justify-start items-center gap-[10px] inline-flex" onClick={() => {
            setIsOpenProfile(!isOpenProfile);
          }}>
              <div className="justify-start items-center gap-2 flex">
                {(() => {
                // Sanitize so dead AWS URLs fall through to <Avatar/>
                // without trying (and failing) the network load.
                const profileUrl = firstValidProfileUrl(users);
                return profileUrl ? <Image className="rounded-lg" src={profileUrl} alt="User Image" width={23} height={23} /> : <Avatar name={users?.firstName} size={23} round={8} />;
              })()}

                <div className="hidden sm:block text-stone-900 text-sm font-medium font-poppins">
                  {users ? users?.firstName : ""}
                </div>
              </div>
              <div className="w-3 h-3">
                <svg fillRule="evenodd" clipRule="evenodd" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M11.7772 2.84763C11.6289 2.69917 11.4531 2.625 11.2499 2.625H0.750056C0.546802 2.625 0.371088 2.69917 0.222628 2.84763C0.0741683 2.99625 0 3.17197 0 3.3751C0 3.57819 0.0741683 3.7539 0.222628 3.9024L5.47257 9.15235C5.6212 9.30081 5.79691 9.37514 6 9.37514C6.20309 9.37514 6.37897 9.30081 6.52731 9.15235L11.7772 3.90236C11.9255 3.7539 12 3.57819 12 3.37506C12 3.17197 11.9255 2.99625 11.7772 2.84763Z" fill="#354EF0" />
                </svg>
              </div>
            </div>
            {/* Desktop Dropdown - hidden on mobile */}
            {isOpenProfile && <div className="hidden sm:block absolute top-10 z-[9999999] right-0 bg-white rounded-md shadow-md">
                <div className="w-[210px] px-4 pb-[17px] bg-white rounded-xl shadow-lg border border-neutral-100 flex-col justify-start items-center gap-2 inline-flex">
                  <div className="self-stretch pt-3.5 pb-[6px] rounded-t-lg px-1 inline-flex">
                    <div>
                      <span className="text-gray-500 text-[11px] font-normal font-poppins leading-none">
                        Last login
                      </span>
                      <br />
                      <span className="text-gray-900 text-xs font-medium font-poppins">
                        {users?.lastLoggedIn ? dayjs(users?.lastLoggedIn).format('MMM DD, YYYY [at] hh:mmA') : "-"}
                      </span>
                    </div>
                  </div>
                  <div className="self-stretch flex-col justify-start items-start gap-1 inline-flex">
                    <div className="text-neutral-400 text-[10px] font-medium font-poppins uppercase tracking-wider">
                      Actions
                    </div>
                    <div className="flex-col justify-start self-stretch items-start gap-0.5 flex">
                      <div onClick={() => {
                    setIsOpenProfile(false);
                    setTimeout(() => {
                      users?.type !== "reps" ? openDoctorsEditProfile() : openUpdateProfilePopUp();
                    }, 50);
                  }} className="justify-start w-full items-center gap-2 cursor-pointer inline-flex py-1.5 px-1 rounded-md hover:bg-gray-50 transition-colors">
                        <LuPenLine size={15} className="text-gray-600" />
                        <div className="text-stone-900 text-[13px] font-normal font-poppins">
                          Edit Profile
                        </div>
                      </div>

                      {users?.type === "reps" && <div className="self-stretch h-[1px] bg-neutral-100 my-0.5"></div>}
                      {users?.type === "reps" && <div onClick={() => {
                    setIsOpenProfile(false);
                    setTimeout(() => openModal(), 50);
                  }} className="justify-start w-full items-center gap-2 cursor-pointer inline-flex py-1.5 px-1 rounded-md hover:bg-gray-50 transition-colors">
                        <LuLock size={15} className="text-gray-600" />
                        <div className="text-stone-900 text-[13px] font-normal font-poppins">
                          Change Password
                        </div>
                      </div>}

                      <div className="self-stretch h-[1px] bg-neutral-100 my-0.5"></div>
                      <div onClick={userLogout} className="justify-start items-center gap-2 cursor-pointer inline-flex py-1.5 px-1 rounded-md hover:bg-red-50 transition-colors w-full">
                        <LuLogOut size={15} className="text-red-500" />
                        <div className="text-red-500 text-[13px] font-normal font-poppins">
                          Logout
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

            {/* Mobile Bottom Sheet */}
            {isOpenProfile && <div className="sm:hidden fixed inset-0 z-[9999999] flex items-end">
                {/* Backdrop */}
                <div className="absolute inset-0 bg-black/40" onClick={() => setIsOpenProfile(false)} />
                {/* Bottom Sheet */}
                <div className="relative w-full bg-white rounded-t-2xl pb-6 max-h-[85vh] overflow-y-auto">
                  {/* Drag handle */}
                  <div className="flex justify-center pt-3 pb-2 sticky top-0 bg-white rounded-t-2xl">
                    <div className="w-10 h-1 bg-gray-300 rounded-full" />
                  </div>

                  {/* Profile Header */}
                  <div className="flex items-center gap-3 px-5 py-3 border-b border-gray-100">
                    {(() => {
                  const profileUrl_0 = firstValidProfileUrl(users);
                  return profileUrl_0 ? <Image className="rounded-full" src={profileUrl_0} alt="User" width={44} height={44} /> : <Avatar name={users?.firstName} size={44} round={22} />;
                })()}
                    <div className="flex-1 min-w-0">
                      <div className="text-[16px] font-semibold text-gray-900 font-poppins truncate">
                        {users?.firstName} {users?.lastName || ""}
                      </div>
                      <div className="text-[12px] text-gray-400 font-poppins">
                        Last login: {users?.lastLoggedIn ? dayjs(users?.lastLoggedIn).format('MMM DD [at] hh:mmA') : "-"}
                      </div>
                    </div>
                  </div>

                  {/* Menu Items */}
                  <div className="px-2 pt-2">
                    {/* Edit Profile */}
                    <div onClick={() => {
                  setIsOpenProfile(false);
                  setTimeout(() => {
                    users?.type !== "reps" ? openDoctorsEditProfile() : openUpdateProfilePopUp();
                  }, 50);
                }} className="flex items-center gap-3 px-4 py-3.5 rounded-xl cursor-pointer active:bg-gray-100 transition-colors">
                      <LuPenLine size={20} className="text-gray-600 flex-shrink-0" />
                      <span className="text-[15px] font-medium text-gray-800 font-poppins">Edit Profile</span>
                    </div>

                    {/* Location - Physician/Clinic only */}
                    {(users?.type === "physician" || users?.type === "clinic") && <div onClick={() => {
                  setIsOpenProfile(false);
                  setTimeout(() => handelOpenEditLocationPopup(), 50);
                }} className="flex items-center gap-3 px-4 py-3.5 rounded-xl cursor-pointer active:bg-gray-100 transition-colors">
                        <IoLocationOutline size={20} className="text-gray-600 flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                          <span className="text-[15px] font-medium text-gray-800 font-poppins">Edit Address</span>
                          {users?.addressDetails?.area && <div className="text-[12px] text-gray-400 font-poppins truncate">{formatAddress(users)}</div>}
                        </div>
                      </div>}

                    {/* Profile Visibility - Physician/Clinic only */}
                    {(users?.type === "physician" || users?.type === "clinic") && <div className="px-4 py-3">
                        <div className="text-[11px] font-medium text-gray-400 font-poppins uppercase tracking-wider mb-2">Profile Visibility</div>
                        <div className="flex gap-2">
                          <button onClick={() => handleVisibilityChange("Private")} className={`flex-1 py-2.5 px-3 rounded-xl text-[13px] font-medium flex items-center justify-center gap-2 transition-all ${visibility === 'Private' ? 'bg-[#354EF0]/10 text-[#354EF0] border-2 border-[#354EF0]' : 'bg-gray-50 text-gray-500 border-2 border-transparent'}`}>
                            <span>Private</span>
                            {visibility === 'Private' && <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>}
                          </button>
                          <button onClick={() => handleVisibilityChange("Public")} className={`flex-1 py-2.5 px-3 rounded-xl text-[13px] font-medium flex items-center justify-center gap-2 transition-all ${visibility === 'Public' ? 'bg-[#354EF0]/10 text-[#354EF0] border-2 border-[#354EF0]' : 'bg-gray-50 text-gray-500 border-2 border-transparent'}`}>
                            <span>Public</span>
                            {visibility === 'Public' && <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>}
                          </button>
                        </div>
                      </div>}

                    {/* Company Selector - Reps only */}
                    {users?.type === "reps" && <div onClick={() => {
                  setIsOpenProfile(false);
                  setTimeout(() => setMobileCompanyOpen(true), 50);
                }} className="flex items-center gap-3 px-4 py-3.5 rounded-xl cursor-pointer active:bg-gray-100 transition-colors">
                      <LuBuilding2 size={20} className="text-gray-600 flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                          <span className="text-[15px] font-medium text-gray-800 font-poppins">Company</span>
                          <div className="text-[12px] text-gray-400 font-poppins truncate capitalize">{companyLabel}</div>
                        </div>
                        <ChevronDown size={16} className="text-gray-400 flex-shrink-0" />
                      </div>}

                    {/* Change Password - Reps only */}
                    {users?.type === "reps" && <div onClick={() => {
                  setIsOpenProfile(false);
                  setTimeout(() => openModal(), 50);
                }} className="flex items-center gap-3 px-4 py-3.5 rounded-xl cursor-pointer active:bg-gray-100 transition-colors">
                      <LuLock size={20} className="text-gray-600 flex-shrink-0" />
                        <span className="text-[15px] font-medium text-gray-800 font-poppins">Change Password</span>
                      </div>}

                    {/* Divider */}
                    <div className="mx-4 h-[1px] bg-gray-100 my-1" />

                    {/* Logout */}
                    <div onClick={userLogout} className="flex items-center gap-3 px-4 py-3.5 rounded-xl cursor-pointer active:bg-red-50 transition-colors">
                      <LuLogOut size={20} className="text-red-500 flex-shrink-0" />
                      <span className="text-[15px] font-medium text-red-500 font-poppins">Logout</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
        <EditLocation user={users} isOpen={isEditLocationPopupOpen} onClose={handelCloseLocationPopup} />

        {/* Modals rendered outside dropdowns so they persist after dropdown closes */}
        {isUpdateProfileOpen && <div className="z-50 fixed inset-0">
            <DynamicComponentWithNoSSR onClose={closeUpdateProfilePopup} />
          </div>}
        {isEditDoctorsProfileOpen && <DoctorsEditProfile onClose={closeDoctorsEditProfile} />}
        {isModalOpen && <ChangePasswordPopup onClose={closeModal} />}

        {/* Mobile Company Selector Popup - Full Screen */}
        {mobileCompanyOpen && users?.type === "reps" && <div className="fixed inset-0 z-[9999] bg-white flex flex-col md:hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-neutral-200 flex-shrink-0">
              <div className="text-[#2E0B34] text-[16px] font-semibold font-poppins">
                My Companies
              </div>
              <div onClick={() => setMobileCompanyOpen(false)} className="w-6 h-6 cursor-pointer flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect width="24" height="24" fill="white" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.00049 17.5864C4.60999 17.977 4.61005 18.6101 5.00061 19.0006C5.39117 19.3911 6.02433 19.3911 6.41482 19.0005L12.0001 13.4143L17.5858 19C17.9763 19.3905 18.6095 19.3905 19 19C19.3905 18.6095 19.3905 17.9763 19 17.5858L13.4142 12L18.9996 6.41359C19.39 6.02303 19.39 5.38987 18.9994 4.99938C18.6089 4.60888 17.9757 4.60894 17.5852 4.9995L11.9999 10.5858L6.41414 4.99998C6.02362 4.60946 5.39045 4.60946 4.99993 4.99998C4.6094 5.39051 4.6094 6.02367 4.99993 6.4142L10.5859 12.0001L5.00049 17.5864Z" fill="#8E8E8E" />
                </svg>
              </div>
            </div>
            <div className="flex-1 min-h-0 flex flex-col">
              <RepCompaniesManager />
            </div>
          </div>}
      </div>}
    </>;
};
export default Navbar;